export default __webpack_public_path__ + "static/media/Terrain_200by200.de1dc049.png";